import axios from "axios";
import Cookies from "js-cookie";
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var encodeObjToURI = function encodeObjToURI2() {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var split = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
  var pairs = [];
  var keys = Object.keys(obj);
  keys.forEach(function(key) {
    var value = obj[key];
    if (["", void 0, null].includes(value)) {
      return;
    }
    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; ++i) {
        pairs.push("".concat(encodeURIComponent("".concat(key, "[").concat(i, "]")), "=").concat(encodeURIComponent(value[i])));
      }
      return;
    }
    pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
  });
  return pairs.join(split);
};
var axiosInstance = axios.create();
var postReportAction = function postReportAction2(params) {
  var str = encodeObjToURI(params);
  return axiosInstance.post("https://h.trace.qq.com/kv", str, {
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    }
  });
};
var imgReportAction = function imgReportAction2(params) {
  var str = encodeObjToURI(params);
  var imgAtta = new Image(1, 1);
  var baseUrl = "https://h.trace.qq.com/kv";
  imgAtta.src = "".concat(baseUrl, "?").concat(str);
};
var ATTA_ID = "0a700064136";
var ATTA_TOKEN = "7162397799";
var base = function() {
  return {
    attaid: ATTA_ID,
    token: ATTA_TOKEN,
    _dc: Date.now()
  };
};
var replaceDivider = function replaceDivider2(str) {
  if (!str) {
    return "";
  }
  return str.replace(/,/g, " ").replace(/\|/g, " ");
};
var isTenvideo = function isTenvideo2() {
  var _window, _window$navigator;
  var ua = ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || "";
  return ua.indexOf("QQLiveBrowser") > -1 || ua.indexOf("QQLiveHDBrowser") > -1;
};
var isIwanAPP = function isIwanAPP2() {
  var _window2, _window2$navigator, _window2$navigator$us;
  return ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : (_window2$navigator$us = _window2$navigator.userAgent) === null || _window2$navigator$us === void 0 ? void 0 : _window2$navigator$us.indexOf("IwanBrowser")) > -1;
};
var isWechat = function isWechat2() {
  var _window3, _window3$navigator, _window3$navigator$us;
  return ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.indexOf("MicroMessenger")) > -1;
};
var isQQ = function isQQ2() {
  var _window4, _window4$navigator;
  return /QQ[\s/]*(\d+(\.\d+)*)/i.test((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$navigator = _window4.navigator) === null || _window4$navigator === void 0 ? void 0 : _window4$navigator.userAgent);
};
var isWeishi = function isWeishi2() {
  var _window5, _window5$navigator;
  var ua = ((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$navigator = _window5.navigator) === null || _window5$navigator === void 0 ? void 0 : _window5$navigator.userAgent) || "";
  return /WEISHI_(\d+(\.\d+)*)/i.test(ua) || (ua === null || ua === void 0 ? void 0 : ua.indexOf("ilive")) > -1;
};
var isSports = function isSports2() {
  var _window6, _window6$navigator;
  return /qqsports/i.test((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$navigator = _window6.navigator) === null || _window6$navigator === void 0 ? void 0 : _window6$navigator.userAgent);
};
var isYYB = function isYYB2() {
  var _window7, _window7$navigator;
  return /qqdownloader\/(\d+)/i.test((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$navigator = _window7.navigator) === null || _window7$navigator === void 0 ? void 0 : _window7$navigator.userAgent);
};
var isQQBrowser = function isQQBrowser2() {
  var _window8, _window8$navigator, _window8$navigator$us;
  return ((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$navigator = _window8.navigator) === null || _window8$navigator === void 0 ? void 0 : (_window8$navigator$us = _window8$navigator.userAgent) === null || _window8$navigator$us === void 0 ? void 0 : _window8$navigator$us.indexOf("MQQBrowser")) > -1;
};
var getPage = function getPage2() {
  var _window;
  var _ref = ((_window = window) === null || _window === void 0 ? void 0 : _window.location) || {}, _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "" : _ref$pathname;
  var index = (pathname === null || pathname === void 0 ? void 0 : pathname.lastIndexOf("/")) + 1;
  var page2 = pathname === null || pathname === void 0 ? void 0 : pathname.slice(index);
  return page2.split(".")[0];
};
var getPlatform = function getPlatform2() {
  var platformList = [{
    check: isTenvideo,
    value: "tenvideo"
  }, {
    check: isIwanAPP,
    value: "iwanapp"
  }, {
    check: isWechat,
    value: "wx"
  }, {
    check: isQQ,
    value: "qq"
  }, {
    check: isWeishi,
    value: "weishi"
  }, {
    check: isSports,
    value: "sports"
  }, {
    check: isYYB,
    value: "yyb"
  }, {
    check: isQQBrowser,
    value: "qqbrowser"
  }, {
    check: function check() {
      return true;
    },
    value: "browser"
  }];
  return platformList.find(function(item) {
    return item.check();
  }).value;
};
var getSystem = function getSystem2() {
  var _window2, _window2$navigator;
  var ua = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent) || "";
  var os = "other";
  if ((ua === null || ua === void 0 ? void 0 : ua.indexOf("Android")) > -1) {
    os = "android";
  } else if (/(iPhone|iPod|iPad)/.test(ua)) {
    os = "ios";
  }
  return os;
};
var getReferrer = function getReferrer2() {
  var _window3;
  if ((_window3 = window) !== null && _window3 !== void 0 && _window3.document) {
    var _window4, _window4$document;
    return (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$document = _window4.document) === null || _window4$document === void 0 ? void 0 : _window4$document.referrer;
  }
  return "";
};
var page = function() {
  var _window5, _window5$location, _window6, _window6$location, _window7, _window7$location, _window8, _window8$navigator;
  return {
    page: getPage(),
    url: replaceDivider((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$location = _window5.location) === null || _window5$location === void 0 ? void 0 : _window5$location.href),
    hostname: replaceDivider((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$location = _window6.location) === null || _window6$location === void 0 ? void 0 : _window6$location.hostname),
    pathname: replaceDivider((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$location = _window7.location) === null || _window7$location === void 0 ? void 0 : _window7$location.pathname),
    referrer: replaceDivider(getReferrer()),
    ua: replaceDivider((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$navigator = _window8.navigator) === null || _window8$navigator === void 0 ? void 0 : _window8$navigator.userAgent),
    platform: getPlatform(),
    system: getSystem()
  };
};
var getAppid = function getAppid2() {
  return Cookies.get("appid") || Cookies.get("vqq_appid") || Cookies.get("sThrAppid") || Cookies.get("yyb_appid");
};
var getOpenid = function getOpenid2() {
  return Cookies.get("openid") || Cookies.get("vqq_openid") || Cookies.get("mobileqopenid") || Cookies.get("wopenid") || Cookies.get("yyb_openid");
};
var getAccesstoken = function getAccesstoken2() {
  return Cookies.get("access_token") || Cookies.get("vqq_access_token") || Cookies.get("accessToken") || Cookies.get("mobileqtoken") || Cookies.get("waccesstoken") || Cookies.get("accesstoken") || Cookies.get("yyb_access_token");
};
var getVuserid = function getVuserid2() {
  return Cookies.get("vuserid") || Cookies.get("vqq_vuserid");
};
var getCookie = function getCookie2() {
  var _window;
  if ((_window = window) !== null && _window !== void 0 && _window.document) {
    var _window2, _window2$document;
    return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : _window2$document.cookie;
  }
  return "";
};
var getAcctype = function getAcctype2() {
  var mainLogin = Cookies.get("main_login");
  var iAuthType = Cookies.get("iAuthType");
  var logintype = Cookies.get("logintype");
  if (mainLogin === "qq" || iAuthType === "1" || logintype === "MOBILEQ") {
    return "qq";
  }
  if (mainLogin === "wx" || iAuthType === "3" || logintype === "WX") {
    return "wx";
  }
  return "";
};
var cookie = function() {
  return {
    cookie: replaceDivider(getCookie()),
    appid: getAppid(),
    openid: getOpenid(),
    accesstoken: getAccesstoken(),
    vuserid: getVuserid(),
    acctype: getAcctype()
  };
};
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var commParams = function() {
  return _objectSpread$1(_objectSpread$1(_objectSpread$1({}, base()), page()), cookie());
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var attaIWAction = function attaIWAction2(params) {
  postReportAction(_objectSpread(_objectSpread({}, commParams()), params));
};
var attaCommonAction = function attaCommonAction2(_ref) {
  var attaid = _ref.attaid, token = _ref.token, params = _ref.params;
  postReportAction(_objectSpread(_objectSpread({}, params), {}, {
    attaid,
    token,
    _dc: Date.now()
  }));
};
var imgAttaIWAction = function imgAttaIWAction2(params) {
  imgReportAction(_objectSpread(_objectSpread({}, commParams()), params));
};
export { attaCommonAction, attaIWAction, imgAttaIWAction };
